<template>
    <div>
        <ContractParentSelection
            :customer-id="customer.id"
            :contract-id="contract.id ? contract.id : 0"
            :product-group-id="productGroup"
            :selected-contract="parentContractSelection"
            :required="false"
            :disabled="(isAddon || (contract.product_can_be_moved !== undefined) ? !contract.product_can_be_moved : false)"
            :label="__('customers.contracts.parent_contract_id')"
            @update="updateParentValue"
        />
        <p
            v-if="errors.parent_contract_id"
            class="help-block text-danger"
        >
            {{ errors.parent_contract_id }}
        </p>
        <p
            v-if="parentSelectedForAddOn"
            class="help-block"
        >
            {{ __('customers.contracts.parent_contract_selected_for_addon') }}
        </p>
    </div>
</template>

<script>
import ContractParentSelection from '~@/Components/Customers/Contracts/ContractParentSelection'

export default {
    name: 'Parent',
    components: { ContractParentSelection },
    props: {
        contract: {
            type: Object,
            default: () => { return {} }
        },
        customer: {
            type: Object,
            default: () => { return {} }
        },
        form: {
            type: Object,
            default: () => { return {} }
        },
        errors: {
            type: Object,
            default: () => { return {} }
        },
        productGroupId: {
            type: Number,
            default: null
        },
        isAddon: {
            type: Boolean,
            default: () => false
        }
    },
    emits: ['updateParentValue'],
    data () {
        return {
            parentSelectedForAddOn: false
        }
    },
    computed: {
        productGroup () {
            return this.productGroupId === null ? null : Number(this.productGroupId)
        },
        parentContractSelection () {
            if (this.contract.contract_id && this.isAddon) {
                return [{
                    value: this.contract.contract_id,
                    label: `${this.contract.product_name} (${this.contract.contract_id})`
                }]
            } else if (this.form.parent_contract_id) {
                return [{
                    value: this.form.parent_contract_id,
                    label: `${this.contract.parent_product_name} (${this.form.parent_contract_id})`
                }]
            }

            return [{ value: '', label: this.__('customers.contracts.no_parent') }]
        }
    },
    methods: {
        updateParentValue (value) {
            if (this.contract.is_product_addon) {
                this.parentSelectedForAddOn = value.value !== ''
            }

            this.$emit('updateParentValue', value)
        }
    }
}
</script>
